<template>
    <button class="btn btn-link p-0 mr-3" @click="exportCustomer()" title="Export Customer Data">
        <i class="fas fa-file-export fa-lg"></i>
    </button>
</template>
<script>
export default {
    props: {
        customerId: Number
    },
    methods: {
        exportCustomer: function () {
            this.exporting = true;
            axios.post('/ajax/admin/customers/' + this.customerId + '/export')
                .then(response => {
                    toastr['success']('Customer data exporting. Check application log for details.', 'Export Customer Data', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                })
                .catch(error => {
                    toastr['error'](error.response.data.message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });
        }
    }
}
</script>